var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7591 8.09784C18.7528 3.67034 14.8908 1.677 11.4983 1.677C11.4983 1.677 11.4983 1.677 11.4887 1.677C8.10576 1.677 4.23409 3.66075 3.22784 8.08825C2.10659 13.0333 5.13493 17.2212 7.87576 19.8566C8.89159 20.8341 10.1949 21.3228 11.4983 21.3228C12.8016 21.3228 14.1049 20.8341 15.1112 19.8566C17.852 17.2212 20.8803 13.0428 19.7591 8.09784ZM11.4983 12.8991C9.83076 12.8991 8.47951 11.5478 8.47951 9.88034C8.47951 8.21284 9.83076 6.86159 11.4983 6.86159C13.1658 6.86159 14.517 8.21284 14.517 9.88034C14.517 11.5478 13.1658 12.8991 11.4983 12.8991Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoPlace);
export default __webpack_public_path__ + "static/media/trvto_place.09fdbb0728cbd3eb5e8624e012fae32b.svg";
export { ForwardRef as ReactComponent };